<template>
  <search-from :fields="fields" :pagination="pagination" @click="onSearch"></search-from>
</template>

<script>
import SearchFrom from "@/components/base/SearchForm";
import {PaginationMeta} from "@/models/PaginationMeta";
import {SearchField} from "@/services/SearchField";
import {parseEnum} from "@/shared/utils";
import {Campaign} from "@/models/NewsLetter/Campaign";
import {RepositoryFactory} from "@/services/repositories/RepositoryFactory";

export default {
  name: "CampaignSearch",
  components: {
    SearchFrom,
  },
  data() {
    return {
      fields: [
        new SearchField()
          .setLabel('Title')
          .setDescription('Filter Campaign Title.')
          .setKey('title')
          .setType(SearchField.FIELD_TYPES.FIELD_TEXT)
          .setIsAdvanced(false)
        ,
        new SearchField()
          .setLabel('Status')
          .setDescription('Filter Status.')
          .setKey('status')
          .setType(SearchField.FIELD_TYPES.FIELD_SELECT)
          .setValues(parseEnum(Campaign.STATUS))
        ,
      ]
    }
  },
  props: {
    pagination: {
      type: Object,
      default: new PaginationMeta(),
    }
  },
  methods: {
    onSearch(params) {
      this.$emit('click', params)
      RepositoryFactory
        .get('newsletterCampaign')
        .searchCampaigns(params)
        .then(
          response => (
            this.$emit('change', response.data)
          )
        )
    },
  }
}
</script>

<style scoped>

</style>
